import { useMatch } from "react-router-dom";
import { listAndDetailSamplesRoutes, listAndDetailSamplesRoutesCombined } from "../../ListAndDetailSamplesNavigation";
import { ListAndDetailSampleEditForm } from "../ListAndDetailSampleEditForm";

export const ListAndDetailSamplesCustomizeViewPage = () => {

    const match = useMatch(listAndDetailSamplesRoutesCombined.customize_viewMatch);
    const cityTownCode = match?.params.cityTownCode;

    return (
        <ListAndDetailSampleEditForm
            listUrl={listAndDetailSamplesRoutes.customize}
            cityTownCode={cityTownCode}
            viewOnly
        />
    )
}
